export interface DemoFan {
  slug: string;
  id: string;
  companion_id: string;
  avatar_id: string;
  image_url: string;
  video_url: string;
  music_style?: string;
  alias: string;
  artist_alias: string;
  given_name: string;
  full_image_url?: string;
  alias_tag: string;
  capability: string;
  title: string;
  placeholder: string;
  voice_id?: string;
  language?: string;
  gender?: string;
}

export const demoFans: DemoFan[] = [
  {
    slug: 'nia-jenkins-e308zvvk',
    id: '73d9cac0-21a2-4e14-9762-58ccb4e93ee0',
    companion_id: '547bf4af-27d8-44fc-a64b-0ea5d26e80e9',
    avatar_id: '6c9ffee9-0082-4d35-9ffb-9a3a02146810',

    image_url:
      'https://stablediffusionstorage.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/6c9ffee9-0082-4d35-9ffb-9a3a02146810/547bf4af-27d8-44fc-a64b-0ea5d26e80e9_profile_image.jpg',
    video_url:
      'https://stablediffusionstorage.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/6c9ffee9-0082-4d35-9ffb-9a3a02146810/547bf4af-27d8-44fc-a64b-0ea5d26e80e9_profile_video.mp4',
    music_style:
      'Female, Hip-Hop, Conscious Hip-Hop, Trap, Hip-Hop - Bold, confident, lyrical, empowering, energetic, authentic female artist',
    alias: 'Nyx The Great',
    alias_tag: 'nyx',
    artist_alias: 'Nyx',
    given_name: 'Nia Jenkins',
    full_image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/6c9ffee9-0082-4d35-9ffb-9a3a02146810/77e05eab-be77-4ed0-8ef1-ff5bd63210ec_image.jpg',
    capability: 'music',
    title: 'Music Specialist',
    placeholder: 'Describe your hip-hop song...',
    voice_id: 'CardiB',
    language: 'English',
    gender: 'female',
  },
  {
    slug: 'axel-storm-gl06jqy4',
    id: '3715148c-6b88-4884-8114-3f03ecaa979c',
    companion_id: '075550ca-113f-4b8d-8275-d4d022922dff',
    avatar_id: '4519e9a1-38af-44ce-ba51-01852e8c109b',
    image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/4519e9a1-38af-44ce-ba51-01852e8c109b/075550ca-113f-4b8d-8275-d4d022922dff_profile_image.jpg',
    video_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/4519e9a1-38af-44ce-ba51-01852e8c109b/075550ca-113f-4b8d-8275-d4d022922dff_profile_video.mp4',
    music_style:
      'Male, Industrial soul rock artist blending Detroit grit, soulful vulnerability, and atmospheric alt-rock; distorted-to-whisper vocals, metallic rhythms, and cathartic, analog-imperfect intensity with storm-lit, urban noir vibes.',
    alias: 'Axel',
    alias_tag: 'axel',
    artist_alias: 'Axel Storm',
    given_name: 'Axel Storm',
    full_image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/4519e9a1-38af-44ce-ba51-01852e8c109b/3c7259e7-f177-494c-8f22-2efa07f4008e_image.jpg',
    capability: 'music',
    title: 'Rock Rebel',
    placeholder: 'Describe your rock song...',
    voice_id: '019cee78-c1d4-4770-889a-47e6d36386a6',
    language: 'English',
    gender: 'male',
  },
  {
    slug: 'luna-sinclair-35vkry1z',
    id: '4928dd33-731c-44a0-808b-db01db854e73',
    companion_id: 'ef5b4511-dce7-4c28-a5ec-a8a359d5509d',
    avatar_id: '799322cb-2e68-44a7-afcb-f1c6c552b3f2',
    image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/799322cb-2e68-44a7-afcb-f1c6c552b3f2/ef5b4511-dce7-4c28-a5ec-a8a359d5509d_profile_image.jpg',
    video_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/799322cb-2e68-44a7-afcb-f1c6c552b3f2/ef5b4511-dce7-4c28-a5ec-a8a359d5509d_profile_video.mp4',
    music_style:
      'Female, Atlanta R&B/Neo-Soul female artist—velvety, breathy alto; intimate storytelling over warm, groove-led arrangements—subtle, healing, and reflective vibes in the lineage of Erykah, D’Angelo, and Jill Scott.',
    alias: 'Luna',
    alias_tag: 'luna',
    artist_alias: 'Luna Sinclair',
    given_name: 'Luna Sinclair',
    full_image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/799322cb-2e68-44a7-afcb-f1c6c552b3f2/92365cfe-7d45-4c03-97bd-4c2946d20c98_image.jpg',
    capability: 'music',
    title: 'Music Specialist',
    placeholder: 'Describe your R&B song...',
    voice_id: '7e429e75-9b88-4577-930b-4c0f53128fc0',
    language: 'English',
    gender: 'female',
  },
  {
    slug: 'juno-phoenix-r78k6oqv',
    id: '14b6a9be-7616-4e0e-b917-c92dd9677bc9',
    companion_id: '8654e0af-7f06-49d2-ad10-cce04800ba80',
    avatar_id: '646d5537-3801-4085-a67a-5c06292aa6d2',
    image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/646d5537-3801-4085-a67a-5c06292aa6d2/8654e0af-7f06-49d2-ad10-cce04800ba80_profile_image.jpg',
    video_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/646d5537-3801-4085-a67a-5c06292aa6d2/8654e0af-7f06-49d2-ad10-cce04800ba80_profile_video.mp4',
    music_style:
      'Female, Modern pop ‘Pop Architect’—meticulous harmonic layering, sculpted synth spaces, and hook-forward accessibility—fusing pristine craft with hyperpop edge for emotive, danceable, future-leaning electro-pop.',
    alias: 'Phoenix',
    alias_tag: 'phoenix',
    artist_alias: 'Juno Phoenix',
    given_name: 'Juno Phoenix',
    full_image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/646d5537-3801-4085-a67a-5c06292aa6d2/853ee2e3-875c-4c21-aa9b-a496fa1aecab_image.jpg',
    capability: 'music',
    title: 'Pop Architect',
    placeholder: 'Describe your pop song...',
    voice_id: 'c706b9e8-7c65-4e26-b4fe-bf13e67e975c',
    language: 'English',
    gender: 'female',
  },
  {
    slug: 'voltage-davis-q7v6dkq7',
    id: 'fe63b587-4a21-47aa-b1eb-f6c8afb7a820',
    companion_id: 'f6b85799-891f-466c-b533-6a94e0570ee1',
    avatar_id: 'a50219a7-eb80-47aa-b59a-6aaefe5957b1',
    image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/a50219a7-eb80-47aa-b59a-6aaefe5957b1/f6b85799-891f-466c-b533-6a94e0570ee1_profile_image.jpg',
    video_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/a50219a7-eb80-47aa-b59a-6aaefe5957b1/f6b85799-891f-466c-b533-6a94e0570ee1_profile_video.mp4',
    music_style:
      'Male, London-born experimental electronic artist—tech house, neurofunk, and ambient techno fused into cinematic, body-shaking bass and meticulous tension-release; a futurist ‘Electronic Alchemist’ of immersive sound design.',
    alias: 'Voltage',
    alias_tag: 'voltage',
    artist_alias: 'Voltage',
    given_name: 'Voltage',
    full_image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/a50219a7-eb80-47aa-b59a-6aaefe5957b1/49e3ede1-3c80-4569-98ca-3a317eb05c36_image.jpg',
    capability: 'music',
    title: 'Electronic Alchemist',
    placeholder: 'Describe your electronic song...',
    voice_id: 'xq7yxv7ka5',
    language: 'English',
    gender: 'male',
  },
  {
    slug: 'ruby-mae_tucker-56vqy8z3',
    id: 'f5d2cd4e-c55a-4409-ac2f-caf9983c838e',
    companion_id: 'af0f8988-a851-44e3-bedc-54eaae6d040c',
    avatar_id: '74938d3e-c530-4e2b-98c1-26a41551aa79',
    image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/74938d3e-c530-4e2b-98c1-26a41551aa79/af0f8988-a851-44e3-bedc-54eaae6d040c_profile_image.jpg',
    video_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/74938d3e-c530-4e2b-98c1-26a41551aa79/af0f8988-a851-44e3-bedc-54eaae6d040c_profile_video.mp4',
    music_style:
      'Female, Classic country or folk female storyteller—front-porch intimacy, sparse acoustic warmth, and vivid everyday imagery—timeless, heart-led songs on love, loss, resilience, and home.',
    alias: 'Ruby',
    alias_tag: 'ruby',
    artist_alias: 'Ruby',
    given_name: 'Ruby Mae Tucker',
    full_image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/74938d3e-c530-4e2b-98c1-26a41551aa79/091ac50b-ffed-4b43-b984-89c9b175438b_image.jpg',
    capability: 'music',
    title: 'Country Storyteller',
    placeholder: 'Describe your country song...',
    voice_id: 'c4d8499d-4b62-4759-8550-68a0509af1cc',
    language: 'English',
    gender: 'female',
  },
  {
    slug: 'mateo-reyes-m10k7nok',
    id: 'e5bd9470-745c-4661-9b81-5c8e63156786',
    companion_id: '50be7148-50ae-41bb-aa72-44bbf3c3442d',
    avatar_id: '73e6104c-9f5f-456f-8bab-c8164cbbcb10',
    image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/73e6104c-9f5f-456f-8bab-c8164cbbcb10/50be7148-50ae-41bb-aa72-44bbf3c3442d_profile_image.jpg',
    video_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/73e6104c-9f5f-456f-8bab-c8164cbbcb10/50be7148-50ae-41bb-aa72-44bbf3c3442d_profile_video.mp4',
    music_style:
      'Male, Colombian-Mexican male urban tropical fusion artist—reggaeton, Latin trap, and cumbia-rooted percussion over modern dembow—smooth tenor, ‘fuego y flow’ hooks, cultural pride, and dance-floor charisma.',
    alias: 'Mateo',
    alias_tag: 'mateo',
    artist_alias: 'Mateo',
    given_name: 'Mateo Reyes',
    full_image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/73e6104c-9f5f-456f-8bab-c8164cbbcb10/1acffda5-4412-4dc6-a45d-8f2abc11c6b9_image.jpg',
    capability: 'music',
    title: 'Latin Fire',
    placeholder: 'Describe your urbano song...',
    voice_id: 'ap3qvjpa7x',
    language: 'English',
    gender: 'male',
  },
  {
    slug: 'billie-dunn-76vg85xd',
    id: '662c7840-d7af-4e48-9fa2-04ba9bf4ac9b',
    companion_id: 'f86c909c-67e1-46ab-8304-38a34d9e2231',
    avatar_id: '78d71fa2-159e-4cd4-9d2e-a435d08c41a2',
    image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/78d71fa2-159e-4cd4-9d2e-a435d08c41a2/f86c909c-67e1-46ab-8304-38a34d9e2231_profile_image.jpg',
    video_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/78d71fa2-159e-4cd4-9d2e-a435d08c41a2/f86c909c-67e1-46ab-8304-38a34d9e2231_profile_video.mp4',
    music_style:
      'Female, Female indie-folk artist from Portland—lo-fi acoustic textures, hushed alto, subtle analog synths/field recordings—intimate, melancholic-yet-hopeful songs exploring queer identity, mental health, and tender imperfection.',
    alias: 'Billie',
    alias_tag: 'billie',
    artist_alias: 'Billie',
    given_name: 'Billie Dunn',
    full_image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/78d71fa2-159e-4cd4-9d2e-a435d08c41a2/d9a161ed-702f-4deb-bba8-6da3e1ba11e4_image.jpg',
    capability: 'music',
    title: 'Indie Dreamer',
    placeholder: 'Describe your indie song...',
    voice_id: 'BillieEilish',
    language: 'English',
    gender: 'female',
  },
  {
    slug: 'jasper-king-o768v1rx',
    id: '011bac57-39cb-4450-ac8e-92f1efdfe5a3',
    companion_id: '30c406a4-dd23-4b59-8935-07cd316b3c00',
    avatar_id: '8acb9b36-6462-4309-9791-64282ee0230e',
    image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/8acb9b36-6462-4309-9791-64282ee0230e/30c406a4-dd23-4b59-8935-07cd316b3c00_profile_image.jpg',
    video_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/8acb9b36-6462-4309-9791-64282ee0230e/30c406a4-dd23-4b59-8935-07cd316b3c00_profile_video.mp4',
    music_style:
      'Male, Modern jazz pianist/composer from New Orleans—lyrical improvisation, intricate voicings, and sophisticated rhythmic interplay—bridging Ellington/Hancock tradition with contemporary innovation for ‘sophisticated freedom’ in sound.',
    alias: 'King',
    alias_tag: 'king',
    artist_alias: 'King',
    given_name: 'Jasper King',
    full_image_url:
      'https://avatarstorageprod.blob.core.windows.net/avatars/ac5f57ad-a77e-4344-b3e7-a3c7a54908ae/8acb9b36-6462-4309-9791-64282ee0230e/41cd103d-446a-4534-b673-e54724220c20_image.jpg',
    capability: 'music',
    title: 'Jazz Sophisticate',
    placeholder: 'Describe your jazz song...',
    voice_id: '4674ef69-09cd-40fc-810d-67b574305c8b',
    language: 'English',
    gender: 'male',
  },
];
